import styled from 'styled-components'

export const UploadContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23A7A7A7FF' stroke-width='2' stroke-dasharray='2%2c6' stroke-dashoffset='10' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 10px;
  padding: 32px;
  cursor: pointer;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const CustomButton = styled.button`
  padding: 8px 15px;
  background: #fff;
  text-align: center;
  color: #1f35b5;
  font-weight: bold;
  font-size: 14px;

  border: 2px solid #1f35b5;
  border-radius: 20px;
  margin-bottom: 20px;
  line-height: inherit;
  :hover {
    background-color: #e8eaf8;
  }
`

export const InstructionsText = styled.div`
  p {
    color: #898989;
    margin-bottom: 20px;
  }
`

export const LimitSizeText = styled.div`
  p {
    color: #898989;
  }
`

export const ErrorText = styled.div`
  margin-bottom: 20px;
  p {
    color: #fc4949;
    text-align: center;
  }
`
